import { render, staticRenderFns } from "./cadgruposplanoscontas.vue?vue&type=template&id=d6b9e228&"
import script from "./cadgruposplanoscontas.vue?vue&type=script&lang=js&"
export * from "./cadgruposplanoscontas.vue?vue&type=script&lang=js&"
import style0 from "./cadgruposplanoscontas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports